import React from 'react';
import { Content } from '~/layouts/Dash/components';


const BasicContent = ({breadcrumb, children}) => {

  const breadcrumbs = [
    {
      label: 'Consultor Técnico',
      to: '/tecnicos/responsavel_tecnico',
      active: false,
    },
    breadcrumb,
  ];
  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Meus Consultores"
    >
      {children}
    </Content>
  );
}

export default BasicContent;
